import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No, es un PDF digital para que empieces hoy mismo. Podrás leerlo en tu celular, tablet o computadora inmediatamente después de la compra.'
  }, {
    q: '¿Necesito comprar algo más?',
    a: 'No. Usamos objetos que ya tienes en casa para realizar los ejercicios y la terapia de frío. No necesitas gastar en equipos costosos.'
  }, {
    q: '¿Es seguro el pago?',
    a: 'Sí, utilizamos cifrado de alta seguridad (SSL de 256 bits) para proteger tus datos. Tu información de pago es procesada por plataformas seguras y nunca almacenamos los datos de tu tarjeta.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-9">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <h2 className="text-3xl font-display font-bold text-center text-slate-900 mb-12" data-id="element-11">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-12">
          {faqs.map((faq, idx) => <div key={idx} className="border border-slate-200 rounded-2xl overflow-hidden bg-slate-50" data-id="element-13">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-14">
                <span className="font-bold text-slate-900 text-lg" data-id="element-15">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-500 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-16" />
              </button>
              <AnimatePresence data-id="element-17">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-18">
                    <div className="p-6 pt-0 text-slate-600 leading-relaxed" data-id="element-19">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}